import { Group, MultiSelect } from '@mantine/core';
import { useUnit } from 'effector-react';
import {
    payinTicketPriorities,
    type PayinTicketPriority,
    payinTicketStatuses,
    type PayinTicketStatus,
} from '~/entities/payin';
import { $ticketsFilter, setTicketsFilter } from '../model';

export const TicketsFilter = () => {
    const filter = useUnit($ticketsFilter);

    return (
        <Group>
            <MultiSelect
                flex={1}
                label='Статус'
                size='xs'
                value={filter.statuses}
                placeholder='Выберите статус'
                data={payinTicketStatuses}
                onChange={(s) => setTicketsFilter({ statuses: s as PayinTicketStatus[] })}
            />

            <MultiSelect
                flex={1}
                size='xs'
                label='Приоритет'
                value={filter.priorities}
                placeholder='Выберите приоритет'
                data={payinTicketPriorities}
                onChange={(p) => setTicketsFilter({ priorities: p as PayinTicketPriority[] })}
            />
        </Group>
    );
};
